module.exports = __webpack_public_path__ + "img/eslint.80f73692.svg";